import React, { useEffect, useState } from "react";
import { Form, Input } from "antd";
import { connect, useSelector } from "react-redux";
import FormItem from "components/fields/FormItem";
import {
  doAddApplicantNotes
} from "../../../../redux/recruitment/recruitmentState";
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from "utils/crudSagaHelper";
import TextArea from "antd/es/input/TextArea";

const AddNotesForm = ({
  doCreate,
  candidate,
  mode,
}) => {
  const [form] = Form.useForm();
  const authUser = useSelector((state) => state.auth.user);

  const onSubmit = (values) => {
    const payload = {
      id: candidate?.jap_id,
      apn_id: 0,
      apn_applicant_id: candidate?.jap_applicant_id,
      apn_user_id: authUser?.id,
      apn_notes: values.apn_notes,
      apn_job_post_id: candidate?.jap_job_post_id
    };

    doCreate(payload);
  };

  return (
    <Form form={form} layout="vertical" className={mode !== "view" ? "form" : ""} onFinish={onSubmit}>
        <FormItem
            className="font-medium mb-2"
            name="apn_notes"
            label="Notes"
            rules={[requiredField]}
          >
            <TextArea
              id="apn_notes"
              className="input-field"
              placeholder="Add notes"
            />
          </FormItem>

      <div className="w-full flex justify-end">
          <CrudButtons
            mode="edit"
            recordId={0}
            isModal
            modalId="add-notes-modal"
            moduleId={0}
          />
      </div>
    </Form>
  );
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({
  doCreate: (data) => dispatch(doAddApplicantNotes(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddNotesForm);
